import { create } from "zustand";
import { InteractionFilterState, InteractionFilterActions } from "./types";
import { InteractionFilterData } from "@/repository/models";

export const useInteractionFilterStore = create<
	InteractionFilterState & InteractionFilterActions
>((set) => ({
	active: { queueIds: [], types: [] } as InteractionFilterData,
	waiting: { queueIds: [], types: [] } as InteractionFilterData,
	setActive: (filterData: InteractionFilterData) => set({ active: filterData }),
	setWaiting: (filterData: InteractionFilterData) =>
		set({ waiting: filterData }),
}));
